import React from "react";

/**
 * Loading skeleton for table bodies. Replaces "Loading..." text with
 * pulsing placeholder rows that hint at the eventual structure.
 *
 * Uses Bootstrap's built-in .placeholder / .placeholder-glow utilities
 * so it inherits the theme's animation timing.
 *
 * Props:
 *  - rows:     number of skeleton rows to render (default 6)
 *  - columns:  number of cells per row OR array of widths like ["20%","40%","20%","20%"]
 *  - height:   per-cell height in px (default 14)
 */
const TableSkeleton = ({ rows = 6, columns = 4, height = 14 }) => {
  const cols = Array.isArray(columns)
    ? columns
    : Array.from({ length: columns }, () => `${100 / columns}%`);

  return (
    <>
      {Array.from({ length: rows }, (_, r) => (
        <tr key={`skel-${r}`}>
          {cols.map((w, c) => (
            <td key={c} style={{ width: w }}>
              <div className="placeholder-glow">
                <span
                  className="placeholder rounded"
                  style={{
                    width: c === 0 ? "70%" : c === cols.length - 1 ? "40%" : "85%",
                    height,
                  }}
                />
              </div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default React.memo(TableSkeleton);
